import styles from "./WhatIncludedSection.module.css";
import firstImage from "../../../../assets/images/pages/ParentsMarathon/section-3-everyday-tasks.png"
import secondImage from "../../../../assets/images/pages/ParentsMarathon/section-3-games-for-speaking.png"
import thirdImage from "../../../../assets/images/pages/ParentsMarathon/section-3-ready-plan.png"
import fourthImage from "../../../../assets/images/pages/ParentsMarathon/section-3-specialist-support.png"
import fifthImage from "../../../../assets/images/pages/ParentsMarathon/section-3-progress-table.png"
import sixthImage from "../../../../assets/images/pages/ParentsMarathon/section-3-bonus-materials.png"

interface FeatureCard {
  readonly title: string;
  readonly description: string;
  readonly icon: string;
}

const FEATURES: FeatureCard[] = [
  {
    title: "Ежедневные задания",
    icon: firstImage,
    description: "Простые занятия на 15–30 минут",
  },
  {
    title: "Игры для запуска речи",
    icon: secondImage,
    description: "Движение, звукоодражание, понимание",
  },
  {
    title: "Готовый план",
    icon: thirdImage,
    description: "Пошаговая программа на каждый день",
  },
  {
    title: "Поддержка специалиста",
    icon: fourthImage,
    description: "Обратная связь от логопеда",
  },
  {
    title: "Таблица прогресса",
    icon: fifthImage,
    description: "Отслеживание появления первых слов",
  },
  {
    title: "Бонус-материалы",
    icon: sixthImage,
    description: "Задания для закрепления результата дома",
  },
];

export const WhatIncludedSection = () => {
  return (
    <section className={styles.section} aria-label="Что будет на марафоне">
      <div className={styles.container}>
        <h2 className={styles.title}>
          Что будет на марафоне{" "}
          <span className={styles.emoji} aria-hidden="true">🎯</span>
        </h2>

        <div className={styles.grid}>
          {FEATURES.map((feature,index) => (
            <article key={feature.title} className={styles.card}>
              {/* Placeholder иконка 80×80 — замени на <img> */}
              {/*<div className={styles.iconPlaceholder} aria-hidden="true" />*/}
              <img src={feature.icon} alt={`feature-icon-${index}`}/>
              <div className={styles.cardText}>
                <h3 className={styles.cardTitle}>{feature.title}</h3>
                <p className={styles.cardDesc}>{feature.description}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};